/* eslint-disable max-len */
/* eslint-disable react-hooks/exhaustive-deps */
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  Checkbox,
  Chip,
  MenuItem,
  Pagination,
  Select,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import {
  DEFAULT_PAGINATION_QUERY,
  INSTITUTION_FILTER_STORAGE,
} from 'api/common.const';
import { ListDropdown } from 'api/common.types';
import { GetAllInstitutionQuery } from 'api/institutions/dtos/get-all-institution.query.dto';
import { getAllInstitution } from 'api/institutions/institution.api';
import { getInstitutionProfilesDropdown } from 'api/profile/profile.api';
import ContainerPainel from 'components/container_painel';
import FiltersDialog from 'components/institution/filters_dialog';
import InstitutionCard from 'components/institution/institution_card';
import { OrderDialog } from 'components/shared';
import { useAuth } from 'contexts/auth/auth_context';
import {
  ModuleEnum,
  PermissionType,
  usePermissions,
} from 'contexts/auth/permission_context';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
import { useInstitutionStore } from 'stores/institution.store';

const Institution: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  console.log('user', user);
  const { hasPermission } = usePermissions();

  useEffect(() => {
    if (!hasPermission(ModuleEnum.INSTITUTIONS, PermissionType.LIST)) {
      alert('Você não tem permissão para acessar esta página.');
      navigate(ROUTES.HOME);
    }
  }, []);

  const loadFiltersFromLocalStorage = () => {
    const storagedFilters = localStorage.getItem(INSTITUTION_FILTER_STORAGE);
    return storagedFilters
      ? JSON.parse(storagedFilters)
      : DEFAULT_PAGINATION_QUERY;
  };

  const [filters, setFilters] = useState<Partial<GetAllInstitutionQuery>>(
    () => {
      const saved = loadFiltersFromLocalStorage();
      return {
        ...saved,
        sortBy: saved.sortBy || 'created_at',
      };
    },
  );
  const [orderBy, setOrderBy] = useState<string>('DESC');
  const [toggleOrderDialog, setToggleOrderDialog] = useState(false);
  const [toggleFiltersDialog, setToggleFiltersDialog] = useState(false);
  const [profilesDropdown, setProfilesDropdown] = useState<ListDropdown[]>([]);
  const [selectedInstitutions, setSelectedInstitutions] = useState<string[]>(
    [],
  );
  const { institution, getInstitution, infoInstitution } =
    useInstitutionStore();

  const applyFilters = async (newFilters: Partial<GetAllInstitutionQuery>) => {
    try {
      const result = await getAllInstitution(newFilters);

      if (result && result.info.count > 0) {
        localStorage.setItem(
          INSTITUTION_FILTER_STORAGE,
          JSON.stringify(newFilters),
        );
        setFilters(newFilters);
        return true;
      }

      return false;
    } catch (error) {
      console.error('Error applying filters:', error);
      return false;
    }
  };

  const hasAppliedFilters = () => {
    const { identification, name, profileUuid, city } = filters;
    return !!(identification ?? name ?? profileUuid ?? city);
  };

  const handleClearFilters = () => {
    localStorage.setItem(
      INSTITUTION_FILTER_STORAGE,
      JSON.stringify(DEFAULT_PAGINATION_QUERY),
    );
    setFilters(DEFAULT_PAGINATION_QUERY);
  };

  const handleSortChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const newFilters: Partial<GetAllInstitutionQuery> = {
      ...filters,
      orderBy: value,
    };
    localStorage.setItem(
      INSTITUTION_FILTER_STORAGE,
      JSON.stringify(newFilters),
    );
    setOrderBy(value);
  };

  const applySort = () => {
    const updatedFilters = {
      ...filters,
      sortBy: 'created_at',
      orderBy,
    };
    localStorage.setItem(
      INSTITUTION_FILTER_STORAGE,
      JSON.stringify(updatedFilters),
    );
    setFilters(updatedFilters);
    setToggleOrderDialog(false);
  };

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked && institution) {
      const intitutionIdList = institution?.map((user: any) => user.uuid);
      setSelectedInstitutions(intitutionIdList);
    } else {
      setSelectedInstitutions([]);
    }
  };

  useEffect(() => {
    const savedFilters = loadFiltersFromLocalStorage();
    if (savedFilters) {
      setFilters(savedFilters);
    }

    const fetchDropdowns = async () => {
      const result = await getInstitutionProfilesDropdown();
      setProfilesDropdown(result.data);
    };

    fetchDropdowns();
  }, []);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number,
  ) => {
    setFilters((prevFilters: any) => ({
      ...prevFilters,
      page: String(page),
    }));
  };

  const handleSelectInstitution = (institutionId: string, checked: boolean) => {
    setSelectedInstitutions((prevSelected) =>
      checked
        ? [...prevSelected, institutionId]
        : prevSelected.filter((id) => id !== institutionId),
    );
  };

  const handleToggleFiltersDialog = () => {
    setToggleFiltersDialog(!toggleFiltersDialog);
  };

  useEffect(() => {
    getInstitution(filters, user?.permission?.name as string);
  }, [filters, user?.permission?.name]);

  return (
    <ContainerPainel pagina='Gerenciar Instituições' showBackButton={true}>
      <Box
        sx={{
          backgroundColor: '#0048B6',
          height: '190px',
          display: 'flex',
          justifyContent: 'center',
          p: '0.5rem',
        }}
      >
        <Box sx={{ width: '1552px' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {/* <Chip
                label='Ordernar'
                onClick={handleToggleOrderDialog}
                onDelete={handleToggleOrderDialog}
                deleteIcon={<ArrowDropDownIcon style={{ color: '#FFFFFF' }} />}
                variant='outlined'
                sx={{
                  color: '#FFFFFF',
                  border: '1px solid #FFFFFF',
                  marginRight: '10px',
                }}
              /> */}
              <Chip
                label='Filtrar'
                onClick={handleToggleFiltersDialog}
                onDelete={handleToggleFiltersDialog}
                variant='outlined'
                deleteIcon={
                  <ArrowDropDownIcon
                    style={{
                      color: hasAppliedFilters() ? '#0048B6' : '#FFFFFF',
                    }}
                  />
                }
                sx={{
                  backgroundColor: hasAppliedFilters() ? '#FFFFFF' : '#0048B6',
                  color: hasAppliedFilters() ? '#0048B6' : '#FFFFFF',
                  border: '1px solid #FFFFFF',
                }}
              />
              {hasAppliedFilters() && (
                <Button
                  variant='text'
                  sx={{ color: '#FFFFFF', marginLeft: '10px' }}
                  startIcon={<CloseIcon />}
                  onClick={handleClearFilters}
                >
                  Limpar filtros
                </Button>
              )}
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              paddingBottom: '10px',
            }}
          >
            <Checkbox
              sx={{ color: '#FFFFFF' }}
              checked={
                selectedInstitutions.length === (institution?.length || 0)
              }
              onChange={handleSelectAll}
            />

            <Typography
              sx={{
                color: '#FFFFFF',
                fontSize: '18px',
                lineHeight: '27px',
              }}
            >
              Selecionar todos |{selectedInstitutions.length} de{' '}
              {institution?.length || 0} selecionado(s)
            </Typography>
          </Box>
          {institution?.map((institution) => {
            return (
              <InstitutionCard
                institution={institution}
                key={institution.uuid}
                isChecked={selectedInstitutions.includes(institution.uuid)}
                onCheckboxChange={(event) => handleSelectInstitution(institution.uuid, event.target.checked)}
                onBlockUser={() => { }}
                blockDisabled={false}
              />
            );
          })}

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '20px',
              marginBottom: '20px',
            }}
          >
            <Pagination
              count={Math.ceil(
                infoInstitution.count /
                parseInt(infoInstitution.take.toString(), 10),
              )}
              page={infoInstitution.page}
              color='primary'
              onChange={handlePageChange}
            />
            <Box display='flex' alignItems='center' gap={1}>
              <Typography variant='body2'>Itens por página:</Typography>
              <Select
                value={
                  infoInstitution.take === infoInstitution.count
                    ? 'all'
                    : infoInstitution.take
                }
                onChange={(e) => {
                  const newTake =
                    e.target.value === 'all'
                      ? infoInstitution.count
                      : Number(e.target.value);
                  setFilters({
                    ...filters,
                    take: String(newTake),
                    page: '1',
                  });
                }}
                size='small'
                renderValue={(selected) => {
                  if (selected === 'all') return 'Todos';
                  return selected;
                }}
              >
                {[5, 10, 25, 50].map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
                <MenuItem key='all' value='all'>
                  Todos
                </MenuItem>
              </Select>
            </Box>
          </Box>
        </Box>
      </Box>

      <OrderDialog
        open={toggleOrderDialog}
        selectedSort={orderBy}
        onClose={() => setToggleOrderDialog(false)}
        handleSortChange={handleSortChange}
        applySort={applySort}
      />
      <FiltersDialog
        open={toggleFiltersDialog}
        onClose={() => setToggleFiltersDialog(false)}
        initialFilter={filters}
        applyFilters={applyFilters}
        profilesDropdown={profilesDropdown}
      />
    </ContainerPainel>
  );
};

export default Institution;
